import { gql, useQuery } from '@apollo/client';

import { getVenues, getVenuesVariables } from './__queries__';
import { useConfig } from '../Components/ConfigProvider';

const GET_VENUES_IDS = gql`
  query getVenues($companyId: ID!) {
    venues: allVenues(filter: { company: { id: $companyId }, active: true, deleted: false }) {
      id
    }
  }
`;

const useIsSingleVenue = () => {
  const config = useConfig();
  const { data: venuesData, loading: venuesLoading } = useQuery<getVenues, getVenuesVariables>(
    GET_VENUES_IDS,
    {
      variables: {
        companyId: config.COMPANY_ID,
      },
    },
  );
  const venues = venuesData?.venues;
  const isSingleVenue = venues?.length === 1;
  const venueId = venues && venues.length > 0 ? venues[0].id : undefined;

  const navigateToLandingWithVenue = () => {
    if (!venueId) {
      return;
    }

    const index = window.location.href.indexOf('#/');
    const search = window.location.search;
    const urlWithoutHash = window.location.href.substring(0, index);
    const param = search.startsWith('?') ? '&v=' : '?v=';
    const url = urlWithoutHash + param + venueId + '#/';

    window.location.replace(url);
  };

  return { navigateToLandingWithVenue, isSingleVenue, venuesLoading };
};

export default useIsSingleVenue;
